<template>
    <form v-if="!completed" ref="form" method="post" class="material-form" :data-form-name="formName">
        <customer-title></customer-title>
        <customer-first-name></customer-first-name>
        <customer-last-name></customer-last-name>
        <customer-email></customer-email>
        <customer-telephone></customer-telephone>

        <generic-textarea input-name="comments" input-title="Anything you'd like to ask?"></generic-textarea>

        <customer-privacy>
            <button @click.prevent="submit" type="button" class="btn btn-primary btn-full-width-xs">Send Enquiry</button>
        </customer-privacy>
    </form>
    <div v-else>
        <h2>Thank you for your enquiry</h2>
        <p class="nice-text">
            Your enquiry has been sent to {{ vehicle.location.used_name }}.
            <br>
            Someone will be in touch soon to discuss your enquiry
        </p>
    </div>
</template>

<script>
import GenericTextarea from "../../Forms/GenericTextarea";

export default {
    components: {
        GenericTextarea,
    },
    props: {
        vehicle: {
            required: true,
        },
        quoteType: {
            required: true,
        },
        term: {
            required: true,
        },
        deposit: {
            required: true,
        },
        mileage: {
            required: true,
        },
    },
    data() {
        return {
            validator: false,
            completed: false,
        };
    },
    computed: {
        formName() {
            if (this.vehicle && this.vehicle.is_new == 1) {
                return 'Physical New Vehicles - Request Quote from Dealer';
            }
            return 'Used Vehicles - Request Quote from Dealer';
        }
    },
    methods: {
        async submit() {
            if (!await this.validator.isValid()) {
                return;
            }

            reCaptchaProtect(() => {
                let formData = new FormData(this.$refs.form);
                formData.set('quote-type', this.quoteType);
                formData.set('term', this.term);
                formData.set('deposit', this.deposit);
                formData.set('mileage', this.mileage);
                this.validator.preventInput();
                axios.post('/api/used-vehicles/request-manual-quote/'+this.vehicle.id, formData)
                    .then(response => {
                        this.gaTag('Used Vehicle', 'Request Finance Quote - ' + this.quoteType, 'Complete');
                        this.trackPageView('/conversion/used-vehicle-enquire-about-finance/complete', 'Used Vehicle Enquire About Finance Completed');
                        this.generateLeadEvent('used_request_finance_quote');

                        this.completed = true;
                        this.$emit('submitted', this.completed);
                        this.validator.allowInput();
                    })
                    .catch(e => {
                        this.validator.errorResponse(e);
                    })
            });
        }
    },
    mounted() {
        this.validator = new ContactFormValidator({
            element: $(this.$refs.form),
            vueForm: true
        });
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Finance/Quotes/ManualQuoteForm.vue